import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
    Grid,
    Button,
    TextField,
    CardContent,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    InputLabel,
    FormControl,
    Select,
    MenuItem,

} from '@material-ui/core';

import { useStyles } from '../../styles';
import { Search, AddCircle } from '@material-ui/icons';
import CircleIcon from '@material-ui/icons/Brightness1';
import { localizationTable, options } from 'constants/table';
import GamificationData from 'services/dataService/GamificationData';
import { useSelector } from 'react-redux';
import { FilesData } from 'services/dataService';
import generateNotifications from 'helpers/NotificationsCenter';
import useAdminPermission from 'customHooks/useAdminPermission';

export default () => {
    const { canCreate } = useAdminPermission('gamification_rewards');
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [name, setName] = useState("");
    const [stock, setStock] = useState(null);
    const [idFile, setIdFile] = useState(null);
    const [filter, setFilter] = useState('');
    const [status, setStatus] = useState(1);
    const [url, setUrl] = useState(null);
    const [cost, setCost] = useState(null);
    const [description, setDescription] = useState("");
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [selectedRewardId, setSelectedRewardId] = useState(null);
    const [photo, setPhoto] = useState(null);

    const tableRef = useRef();
    const classes = useStyles();
    const { register, handleSubmit, control } = useForm();

    const { t } = useTranslation([
        'label',
        'toastify',
        'tables',
        'form',
        'button',
        'validation',
    ]);

    const FieldWithStatus = ({ circleStyle, text }) => (
        <div style={{ display: 'flex' }}>
            <CircleIcon fontSize="small" style={{ color: `${circleStyle}` }} />
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>{text}</span>
        </div>
    );

    const handleSubmitFilter = (data) => {
        setFilter(data.filter);

        tableRef.current.state.query.page = 0;
        tableRef.current.onQueryChange();
    };

    const { id_company, name: studentName, idStudentUser, email } = useSelector(
        (state) => state.auth
    );

    async function handleAddReward(event, data) {
        event.preventDefault();

        const { name, cost, stock, description, id_company, status} = data;

        const newName = photo.name.replace(/\s+/g, "_");
        const renamedFile = new File([photo], newName, { type: photo.type });

        const responseFile = await FilesData.addFile(renamedFile, 'Reward');


        const rewardResponse = await GamificationData.createReward({
            name: name,
            cost: cost,
            stock: stock,
            description: description,
            status: status,
            id_company: id_company,
            id_file: responseFile.data.id
        })

        if (rewardResponse.status === 200) {
            setIsModalOpen(!isModalOpen);
            setFeedbackMessage("Recompensa adicionada com sucesso");

            await generateNotifications("newRewards", {
                name: studentName,
                user: idStudentUser,
                company: id_company,
                read: false,
                email: email
            });

            setTimeout(() => {
                setFeedbackMessage(null);
            }, 2000)
            tableRef.current && tableRef.current.onQueryChange();
        }

        if (rewardResponse.status !== 200) {
            setFeedbackMessage("Erro ao adicionar recompensa");
            setTimeout(() => {
                setFeedbackMessage(null);
            }, 2000)
            tableRef.current && tableRef.current.onQueryChange();
        }

    }

    async function handleEditReward(event, data) {
        event.preventDefault();
        let responseFile = null;

        if (photo) {
            const newName = photo.name.replace(/\s+/g, "_");
            const renamedFile = new File([photo], newName, { type: photo.type });

            responseFile = await FilesData.addFile(renamedFile, 'Reward');
        } else {
            console.warn("Nenhuma foto foi fornecida para o upload.");
        }

        try {
            const rewardResponse = await GamificationData.updateReward({
                id_reward: selectedRewardId,
                data: {
                    name: data.name,
                    cost: data.cost,
                    stock: data.stock,
                    description: data.description,
                    status: data.status,
                    id_company: id_company,
                    id_file: responseFile?.data?.id ? responseFile?.data?.id : idFile
                }
            });

            if (rewardResponse.status === 200) {
                setIsModalOpen(!isModalOpen);
                setFeedbackMessage("Recompensa editada com sucesso");
                setTimeout(() => {
                    setFeedbackMessage(null);
                    // window.location.reload();
                }, 2000)
                tableRef.current && tableRef.current.onQueryChange();
            } else {
                setFeedbackMessage("Erro ao editar recompensa");
            }
        } catch (error) {
            console.error(error);
            toast.error("Erro ao editar recompensa.");
            setTimeout(() => {
                setFeedbackMessage(null);
            }, 2000)
        }

    }

    async function handleDeleteReward(event, idReward) {
        event.preventDefault();
        try {
            const deletedReward = await GamificationData.deleteReward({ id: idReward });

            if (deletedReward.status === 204) {
                setIsModalOpen(!isModalOpen);
                setFeedbackMessage("Recompensa excluída com sucesso!");
                setTimeout(() => {
                    setFeedbackMessage(null);
                }, 2000);
                tableRef.current && tableRef.current.onQueryChange();

            }
        } catch (error) {
            console.error(error);
            if (error.response && error.response.data && error.response.data.error) {
                const errorMessage = error.response.data.error;
                if (errorMessage.includes('associated with user rewards')) {
                    toast.error("Este produto possui itens resgatados e não pode ser excluído.");
                } else {
                    toast.error(errorMessage);
                }
            } else {
                toast.error("Erro ao deletar recompensa.");
            }
        }
    }

    return (
        <div className='notranslate'>
            {feedbackMessage && (
                <div className={classes.feedbackMessageContainer}>
                    <p>{feedbackMessage}</p>
                </div>
            )}

            <Dialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                {/* ADD */}
                {modalType === "add" && (
                    <>
                        <DialogTitle>Adicionar Recompensa</DialogTitle>
                        <DialogContent dividers>
                            <form
                                className={classes.modalForm}
                                onSubmit={(event) =>
                                    handleAddReward(event, { name, cost, stock, description, status, id_company })
                                }
                            >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Nome"
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Estoque"
                                    type="number"
                                    onChange={(e) => setStock(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Custo"
                                    type="number"
                                    onChange={(e) => setCost(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Descrição"
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        value={status}
                                        onChange={(e) => setStatus(Number(e.target.value))}
                                        label="Status"
                                    >
                                        <MenuItem value={1}>Ativo</MenuItem>
                                        <MenuItem value={2}>Inativo</MenuItem>
                                    </Select>
                                </FormControl>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setPhoto(e.target.files[0])}
                                    style={{ marginTop: "12px" }}
                                />
                                <Typography variant="caption">
                                    Tamanho sugerido da imagem: 500x281
                                </Typography>
                                <DialogActions>
                                    <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
                                    <Button type="submit" variant="contained" color="primary">
                                        Adicionar
                                    </Button>
                                </DialogActions>
                            </form>
                        </DialogContent>
                    </>
                )}

                {/* EDIT */}
                {modalType === "edit" && (
                    <>
                        <DialogTitle>Editar Recompensa</DialogTitle>
                        <DialogContent dividers>
                            <form
                                className={classes.modalForm}
                                onSubmit={(event) =>
                                    handleEditReward(event, { name, cost, stock, description, status, id_company })
                                }
                            >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Nome"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Estoque"
                                    type="number"
                                    value={stock}
                                    onChange={(e) => setStock(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Custo"
                                    type="number"
                                    value={cost}
                                    onChange={(e) => setCost(e.target.value)}
                                />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Descrição"
                                    multiline
                                    rows={3}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                 <FormControl fullWidth variant="outlined">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        value={status}
                                        onChange={(e) => setStatus(Number(e.target.value))}
                                        label="Status"
                                    >
                                        <MenuItem value={1}>Ativo</MenuItem>
                                        <MenuItem value={2}>Inativo</MenuItem>
                                    </Select>
                                </FormControl>
                                <div
                                    style={{
                                        margin: "10px 0",
                                        width: "100%",
                                        height: "200px",
                                        overflow: "hidden",
                                        borderRadius: "8px"
                                    }}
                                >
                                    <img
                                        src={url}
                                        alt="preview"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setPhoto(e.target.files[0])}
                                />
                                <Typography variant="caption">
                                    Tamanho sugerido da imagem: 500x281
                                </Typography>
                                <DialogActions>
                                    <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
                                    <Button type="submit" variant="contained" color="primary">
                                        Salvar
                                    </Button>
                                </DialogActions>
                            </form>
                        </DialogContent>
                    </>
                )}

                {/* DELETE */}
                {modalType === "delete" && (
                    <>
                        <DialogTitle>Remover Recompensa</DialogTitle>
                        <DialogContent dividers>
                            <Typography>
                                Deseja apagar a recompensa <strong>{name}</strong>?
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setIsModalOpen(false)}>Não</Button>
                            <Button
                                onClick={(event) => handleDeleteReward(event, selectedRewardId)}
                                color="error"
                                variant="contained"
                            >
                                Sim
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>

            <Grid container spacing={1} style={{ marginTop: 20 }}>
                <Grid item md={5} xs={12}>
                    <Typography variant="h4">
                        Gestão de recompensas:
                    </Typography>
                </Grid>
                <Grid item md={7} className={classes.actions}>
                    <Button
                        color="primary"
                        variant="contained"
                        disabled={!canCreate}
                        onClick={() => {
                            setIsModalOpen(true);
                            setModalType("add");
                        }}
                    >
                        <AddCircle style={{ marginRight: '5px' }} />
                        Adicionar Recompensa
                    </Button>
                </Grid>
            </Grid>
            <MaterialTable
                style={{ marginTop: 30 }}
                title={`${t('Recompensas')}`}
                tableRef={tableRef}
                columns={[
                    {
                        title: `${t('Nome')}`,
                        field: `name`,
                        sorting: false,
                        render: (rowData) => rowData.name,
                    },
                    {
                        title: `${t('Custo')}`,
                        sorting: false,
                        field: 'cost',
                        render: (rowData) => rowData.cost,
                    },
                    {
                        title: `${t('Estoque')}`,
                        field: 'stock',
                        sorting: false,
                        render: (rowData) => rowData.stock,
                    },
                    {
                        title: `${t('Status')}`,
                        field: 'status',
                        sorting: false,
                        render: (rowData) => (
                            <FieldWithStatus
                                text={rowData.status == 1 ? "Ativo" : "Inativo"}
                                circleStyle={rowData.status == "1" ? "green" : "red"}

                            />
                        ),
                    },
                    {
                        title: `${t('Descrição')}`,
                        field: 'description',
                        sorting: false,
                        render: (rowData) =>
                            rowData.description,
                    },
                ]}
                data={async (query) => {
                    try {
                        const rewardsResponse = await GamificationData.getAllRewards({
                            id_company,
                            page: query.page + 1,
                            limit: query.pageSize,
                            filter,
                        });
                        const { data: { allRewards } } = rewardsResponse;
                        setIsLoading(false);

                        return {
                            data: allRewards,
                            page: rewardsResponse.data.currentPage - 1,
                            totalCount: rewardsResponse.data.totalCount,
                        };
                    } catch (err) {
                        if (err.response?.status === 403) {
                            toast.error(t('toastify:commons.toast_error_403'));
                        } else {
                            toast.error(t('toastify:commons.toast_error_api'));
                        }
                        setIsLoading(false);

                        return { data: [] };
                    }
                }}
                components={{
                    search: true,
                    title: false,
                    Toolbar: (props) => (
                        <div>
                            <MTableToolbar {...props} />
                            <form onSubmit={handleSubmit(handleSubmitFilter)}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item md={8} xs={12}>
                                            <TextField
                                                fullWidth
                                                label={t('form:commons.input_search')}
                                                name="filter"
                                                type="text"
                                                variant="outlined"
                                                defaultValue={filter || ''}
                                                inputRef={register}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12} className={classes.actions}>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                size="small"
                                                type="submit"
                                            >
                                                <Search style={{ marginRight: '5px' }} />
                                                {t('button:commons.btn_advanced_filter')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </form>
                        </div>
                    ),
                }}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: `Editar`,
                        position: 'row',
                        onClick: (event, rowData) => {
                            event.preventDefault();
                            setIsModalOpen(!isModalOpen);
                            setModalType("edit");
                            setName(rowData.name);
                            setCost(rowData.cost);
                            setStock(rowData.stock);
                            setStatus(rowData.status);
                            setDescription(rowData.description);
                            setIdFile(rowData.id_file);
                            setUrl(rowData.file?.url);
                            rowData.id && setSelectedRewardId(rowData.id);
                        },
                        iconProps: { color: 'primary' },
                    },
                    {
                        icon: 'delete',
                        tooltip: `Remover`,
                        position: 'row',
                        onClick: (event, rowData) => {
                            event.preventDefault();
                            setIsModalOpen(!isModalOpen);
                            setModalType("delete");
                            setName(rowData.name);
                            setCost(rowData.cost);
                            setStock(rowData.stock);
                            setStatus(rowData.status);
                            setDescription(rowData.description);
                            rowData.id && setSelectedRewardId(rowData.id);
                        },
                        iconProps: { color: 'primary' },
                    },
                ]}
                isLoading={isLoading}
                localization={localizationTable(t)}
                options={options}
            />
        </div>

    );
};
